<extra-information [tipContent]="'property.renovation.tip' | apContent"></extra-information>

<next-button (click)="nextQuestion()"></next-button>
